import ArrayUtils from '../../utils/ArrayUtils'
import GraphicsUtils from '../../utils/GraphicsUtils'

function BaseWithReferenceAreaProjection(referenceAreas, referencePoints) {
    this._referenceAreas = ArrayUtils.copy(referenceAreas);
    this._referencePoints = ArrayUtils.copy(referencePoints);
}

BaseWithReferenceAreaProjection.prototype._getReferenceArea = function(areas, isInAreaFunction, data) {
    if (areas) {
        for (var i = 0; i < areas.length; i++) {
            if (isInAreaFunction(data, areas[i])) {
                var result = this._getReferenceArea(areas[i].referenceAreas, isInAreaFunction, data);
                if (result) {
                    return result;
                }
                return areas[i];
            }
        }
    }
    return null;
}

BaseWithReferenceAreaProjection.prototype.isLocationInArea = function(location, area) {
    return GraphicsUtils.isLocationInPolygon(location, area.shapeLocations);
}

BaseWithReferenceAreaProjection.prototype.isPointInArea = function(point, area) {
    return GraphicsUtils.isPointInPolygon(point, area.shapePoints);
}

BaseWithReferenceAreaProjection.prototype._getAreaReferences = function(isInAreaFunction, data) {
    var area = this._getReferenceArea(this._referenceAreas, isInAreaFunction, data);
    if (area) {
        return area.referencePoints;
    }
    return this._referencePoints;
}

BaseWithReferenceAreaProjection.prototype.getProjectionReferencesForLocation = function(location, skipArea = false) {
    if (skipArea) {
        return this._referencePoints;
    } else {
        return this._getAreaReferences(this.isLocationInArea, location);
    }
}

// eslint-disable-next-line no-unused-vars
BaseWithReferenceAreaProjection.prototype.getProjectionReferencesForPoint = function(point, skipArea = false) {
    if (skipArea) {
        return this._referencePoints;
    } else {
        return this._getAreaReferences(this.isPointInArea, location);
    }
}

export default BaseWithReferenceAreaProjection;